import BaseModel from './base-modeles/base-model';
import _has from 'lodash/has';
import _set from 'lodash/set';
import _get from 'lodash/get';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { ISectionModel } from '@src/slide/domain/ui-model/element-modeles/Interface/section-model.interface';
import ModelConverterBridge from '@src/slide/domain/ui-model/element-modeles/convert/model-converter-bridge';

interface ISectionModelProps {
    sectionIndex: number;
    name: string;
    numSlides: number;
}

// 左侧幻灯片列表节的 model
export default class SectionModel extends BaseModel implements ISectionModel {
    public static async convertDataSdkToUi(sdkData: any, uiData: any, rawSdkData: any, option?: any): Promise<void> {
        super.convertDataSdkToUi(sdkData, uiData, rawSdkData, option);
        if (_get(sdkData, 'name')) {
            _set(uiData, 'name', sdkData.name);
        }
        if (typeof _get(sdkData, 'numSlides') === 'number') {
            _set(uiData, 'numSlides', sdkData.numSlides);
        }
        ModelConverterBridge.convertSdkToUi({
            type: UIModelType.SECTION,
            sdkData,
            uiData,
        });
    }

    public static convertDataUiToSdk(uiData: any, sdkData: any, rawUiModel: any, option?: any): void {
        super.convertDataUiToSdk(uiData, sdkData, rawUiModel, option);
        if (_has(uiData, 'props.name')) {
            _set(sdkData, 'name', uiData.props.name);
        }
        if (_has(uiData, 'props.numSlides')) {
            _set(sdkData, 'numSlides', uiData.props.numSlides);
        }
    }

    public sectionIndex = -1;
    public name = '';
    public numSlides = 0;

    public constructor(props?: Partial<ISectionModelProps>) {
        super(props as any);
        this.type = UIModelType.SECTION;
        if (props) {
            this.sectionIndex = props.sectionIndex ?? -1;
            this.name = props.name ?? '';
            this.numSlides = props.numSlides ?? 0;
        }
    }
}
